export default [
  {
    path: 'login/:tid?',
    name: 'MobileLogin',
    component: () => import ('@/mobile/login.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: 'authorizationLogin',
    name: 'AuthorizationLogin',
    component: () => import ('@/mobile/authorizationLogin.vue'),
    meta: {
      title: '授权登录'
    }
  },
  {
    path: 'authorizationRegister',
    name: 'AuthorizationRegister',
    component: () => import ('@/mobile/authorizationLogin.vue'),
    meta: {
      title: '注册'
    }
  },
  {
    path: 'authenticationResult',
    name: 'AuthenticationResult',
    component: () => import ('@/mobile/authenticationResult.vue'),
    meta: {
      title: '认证结果'
    }
  },
  {
    path: 'help',
    name: 'Help',
    component: () => import ('@/mobile/help.vue'),
    meta: {
      title: '帮助视频'
    }
  }
]
